import React, { useState } from 'react';
import { useApiEffect } from 'framework/hooks/useApiEffect';
import {
	IInventoryItemsQueryParamsForReturn,
	inventoryItemsQuery_queryForReturn,
	IProductCatalogQueryParamsForReturn,
	productCatalogQuery_queryForReturn,
} from 'gen/ApiClient';
import { DefaultInventoryItemsQueryParamsForReturn } from 'shared/searchAndSelect/DefaultInventoryItemsQueryParamsForReturn';
import { SearchContext } from './SearchContext';

const DefaultPcParams: IProductCatalogQueryParamsForReturn = {
	searchString: '',
	sortParams: { direction: 'desc', property: 'created' },
	pageParams: { index: 1, size: 10 },
	types: [],
	categories: [],
	subcategories: [],
};

interface IProps {
	children: any;
}

export const SearchProvider = ({ children }: IProps) => {
	const [pcParams, setPcParams] = useState<IProductCatalogQueryParamsForReturn>(DefaultPcParams);
	const [pcQueryResult] = useApiEffect(productCatalogQuery_queryForReturn, pcParams);
	const [iiParams, setIIParams] = useState<IInventoryItemsQueryParamsForReturn>(DefaultInventoryItemsQueryParamsForReturn);
	const [iiQueryResult] = useApiEffect(inventoryItemsQuery_queryForReturn, iiParams);

	return (
		<SearchContext.Provider
			value={{
				pcParams: pcParams,
				pcQueryResult: pcQueryResult,
				setPcParams: setPcParams,
				iiParams: iiParams,
				iiQueryResult: iiQueryResult,
				setIIParams: setIIParams,
			}}>
			{children}
		</SearchContext.Provider>
	);
};
